var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 22L10 20.8L14.8 16L10 11.2L11.2 10L16 14.8L20.8 10L22 11.2L17.2 16L22 20.8L20.8 22L16 17.2L11.2 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircle);
export default __webpack_public_path__ + "static/media/deleteCircle.4353b9cf6dd59a92cef0106fe87ae4bd.svg";
export { ForwardRef as ReactComponent };